import { isSameEntry } from '../models/legacyStockEntry';

export const legacyChartScrollCooldown = 2500;
export const legacyChartFullPrefetchLimit = 100;

export function legacyChartPrefetchAll(entries) {
  const symbols = new Set();
  for (const entry of entries || []) {
    symbols.add(String(entry && entry.ticker || '').toUpperCase());
    if (symbols.size > legacyChartFullPrefetchLimit) return false;
  }
  return true;
}

// The list order is authoritative, including LT/RR rows for the same ticker.
// Binary search avoids reading thousands of offscreen row rectangles per click.
export function legacyChartPrefetchPlan(entries, selected, viewport) {
  entries = Array.isArray(entries) ? entries : [];
  const cursor = entries.findIndex(entry => isSameEntry(entry, selected));
  const indices = new Set();
  let anchor = Math.max(0, cursor);
  const add = index => { if (index >= 0 && index < entries.length && index !== cursor) indices.add(index); };
  if (cursor >= 0) {
    for (let offset = 1; offset <= 5; offset++) add(cursor + offset);
    for (let offset = 1; offset <= 5; offset++) add(cursor - offset);
  }
  if (viewport) {
    const bounds = viewport.getBoundingClientRect();
    const rows = viewport.querySelectorAll('li[role="option"]');
    if (bounds.height > 0 && rows.length === entries.length) {
      const firstAfter = test => {
        let low = 0, high = rows.length;
        while (low < high) {
          const middle = Math.floor((low + high) / 2);
          if (test(rows[middle].getBoundingClientRect())) high = middle;
          else low = middle + 1;
        }
        return low;
      };
      const first = firstAfter(rect => rect.bottom > bounds.top);
      const end = firstAfter(rect => rect.top >= bounds.bottom);
      if (first < end) {
        if (cursor < first || cursor >= end) anchor = Math.floor((first + end - 1) / 2);
        for (let index = first; index < end; index++) add(index);
        for (let offset = 1; offset <= 5; offset++) { add(end - 1 + offset); add(first - offset); }
      }
    }
  }
  const all = legacyChartPrefetchAll(entries);
  if (all) entries.map((_, index) => index)
    .sort((a, b) => Math.abs(a - anchor) - Math.abs(b - anchor) || b - a).forEach(add);
  return { entries: [...indices].map(index => entries[index]), anchor, all };
}

export function legacyChartPrefetchEntries(entries, selected, viewport) {
  return legacyChartPrefetchPlan(entries, selected, viewport).entries;
}
